module.exports = __webpack_public_path__ + "static/media/Apartment-2@2x.31e73b5f.png";